import {createStackNavigator} from '@react-navigation/stack';

const createPlatformStackNavigator: typeof createStackNavigator = () => createStackNavigator();

export default createPlatformStackNavigator;
